import script from "./viewNote.vue?vue&type=script&setup=true&lang=js"
export * from "./viewNote.vue?vue&type=script&setup=true&lang=js"

import "./viewNote.vue?vue&type=style&index=0&id=17c93840&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17c93840"]])

export default __exports__